import React from 'react'
import * as a from '../'
import {useAuth} from '../../../../app/modules/auth'

type Props = {
  containerClassName?: string
  className?: string
  disabled?: boolean
  displayText?: string
  displayEmptyOption?: boolean
  dropdownData: string
  errors?: any
  fieldProps: any
  onChange?: (value: string | number) => void // New prop for the onChange event
  toolTip?: string
  touched?: any
  useNumericValues?: boolean
  valueDescription?: string
  valueType?: string
  verticalLabel?: boolean
  width?: string
  comparisonValue?: any
}

export const DEFAULT_SETTINGS_PROPS = {
  valueType: 'settingName',
  valueDescription: 'settingDescription',
}

export const AncientDropdownInstanceSetting: React.FC<Props> = ({
  containerClassName,
  className,
  disabled,
  displayText,
  displayEmptyOption = true,
  dropdownData,
  errors,
  fieldProps,
  onChange,
  toolTip,
  touched,
  useNumericValues,
  valueDescription,
  valueType,
  verticalLabel,
  width,
  comparisonValue
}) => {
  const {currentInstanceSettings} = useAuth()

  const dropdownDataList = currentInstanceSettings
    ? currentInstanceSettings[dropdownData as keyof typeof currentInstanceSettings]
    : []

  const handleOnChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    let value: string | number = e.target.value
    if (useNumericValues) {
      value = Number(value)
    }

    onChange?.(value)
  }

  const dropdown = () => {
    const selectProps = {
      className: 'form-select form-select-solid fw-bolder ' + className,
      style: {width: width ? width : 'auto'},
      'data-kt-select2': 'true',
      'data-placeholder': 'Select option',
      'data-allow-clear': 'true',
      'data-kt-user-table-filter': 'role',
      'data-hide-search': 'true',
      ...fieldProps,
      ...(onChange && {onChange: handleOnChange}), // Add onChange only if it exists
      ...(disabled && {disabled}),
    }

    return (
      <>
        <select {...selectProps}>
          {displayEmptyOption && <option></option>}
          {dropdownDataList?.map((setting) => {
            let valueSetting
            let valueDisplay

            if (valueType) {
              valueSetting = useNumericValues
                ? Number(setting?.[valueType])
                : setting?.[valueType]?.toString()
            } else {
              valueSetting = setting?.id?.toString()
            }

            if (valueDescription) {
              valueDisplay = setting?.[valueDescription]?.toString()
            } else {
              valueDisplay = setting?.settingName?.toString()
            }
            const isPreviousSelection = valueSetting === comparisonValue;

            return (
              <option key={valueSetting} value={valueSetting}>
                {valueDisplay} {isPreviousSelection && '- Current Selection'}
              </option>
            )
          })}
        </select>
      </>
    )
  }

  return (
    <>
      {verticalLabel ? (
        <a.AncientFormWrapVertical
          displayText={displayText}
          toolTip={toolTip}
          className={containerClassName}
        >
          {dropdown()}
        </a.AncientFormWrapVertical>
      ) : (
        <a.AncientFormWrapHorizontal
          displayText={displayText}
          toolTip={toolTip}
          className={containerClassName}
        >
          {dropdown()}
        </a.AncientFormWrapHorizontal>
      )}
    </>
  )
}
